import { Component, inject, OnDestroy } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";

@Component({
  selector: "app-pdv-pin-dialog",
  imports: [MatDialogModule],
  template: `
    <h2 mat-dialog-title>PIN de autorização do PDV</h2>
    <mat-dialog-content>
      <p>{{ data.email }}</p>
      <p>
        Guarde este PIN com segurança e entregue somente ao aprovador. Ele é
        exibido apenas agora e não fica salvo no navegador.
      </p>
      <p>
        <strong class="fs-3" aria-label="PIN gerado">{{ data.pin }}</strong>
      </p>
      @if (data.pending) {
        <p>
          O PIN do convite ficará disponível para uso quando o colaborador
          aceitar.
        </p>
      }
      <p>
        Se um novo PIN foi gerado, o anterior deixa de funcionar. O PIN não
        autoriza acesso a outros eventos.
      </p>
    </mat-dialog-content>
    <mat-dialog-actions align="end"
      ><button class="btn btn-primary" (click)="dialog.close()">
        Guardei o PIN
      </button></mat-dialog-actions
    >
  `,
})
export class PdvPinDialogComponent implements OnDestroy {
  readonly data = inject<{ pin: string; email?: string; pending?: boolean }>(
    MAT_DIALOG_DATA,
  );
  readonly dialog = inject(MatDialogRef<PdvPinDialogComponent>);
  ngOnDestroy() {
    this.data.pin = "";
  }
}
